export const CUSTOMER = 1;
export const DENTIST = 2;
export const PARTNER = 3;
export const CONTACT = 4;
export default [
  CUSTOMER,
  DENTIST,
  PARTNER,
  CONTACT,
];